import {
  Button,
  Box,
  Typography,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Stack,
  FormLabel,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import HipShipGreen from "../assests/logo/hipShipGreen.png";
import { shopifyLogin, userLogin } from "../config/api";
import loginImage from "../assests/login.svg";
import { StyledInput } from "../components/ui/StyledInput";
import toast from "react-hot-toast";

interface FormData {
  username: string;
  password: string;
}

const Login = () => {
  const [type, setType] = useState("password");
  const [searchParams, setSearchParams] = useSearchParams();
  const [isShopify, setIsShopify] = useState(false);

  useEffect(() => {
    const channelFromParams = searchParams.get("channel");

    if (channelFromParams === "shopify") {
      setIsShopify(true);
    }
  }, [searchParams]);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // console.log(isShopify);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const navigate = useNavigate();
  const location = useLocation();

  const [formData, setFormData] = useState<FormData>({
    username: "",
    password: "",
  });
  const [isError, setIsError] = useState({ username: "", password: "" });

  const [canSubmit, setCanSubmit] = useState(false);

  const passwordLength = (value: string, limit: number) =>
    value.slice(0, limit);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    // if (name === "password") {
    //   setFormData({ ...formData, [name]: passwordLength(value, 8) });
    // } else {
    setFormData({ ...formData, [name]: value });
    // }
  };

  useEffect(() => {
    if (formData.username) {
      setCanSubmit(true);
    }
    if (formData.username === "" || formData.password.length < 1) {
      setCanSubmit(false);
    }
  }, [formData]);

  const validateForm = ({ password }: { password: string }) => {
    let errors = {
      username: "",
      password: "",
    };

    let haveErros = false;

    if (password.length < 6) {
      errors.password = "Password must be at least 6 characters long";
      haveErros = true;
    }

    setIsError(errors);

    return haveErros;
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const { username, password } = formData;

    if (!validateForm(formData)) {
      if (!isShopify) {
        userLogin({ username, password })
          .then((data) => {
            console.log(data);

            localStorage.setItem("hipship-token", data.data.data.token);
            localStorage.setItem("hipship-username", data.data.data.username);
            localStorage.setItem("hipship-user-id", data.data.data.user_id);

            toast.success("Welcome Back!");
            navigate(location.state?.prevurl || "/");
            setFormData({
              username: "",
              password: "",
            });
          })
          .catch((error) => {
            toast.error("Invalid username or password!");
            console.log(error);
          });
      } else {
        const access_token = searchParams.get("access_token") ?? "";
        const channel = searchParams.get("channel") ?? "";
        const shop = searchParams.get("shop") ?? "";

        shopifyLogin({ username, password, access_token, channel, shop })
          .then((data) => {
            localStorage.setItem("hipship-token", data.data.data.token);
            localStorage.setItem("hipship-username", data.data.data.username);
            toast.success("Welcome Back!");
            navigate(location.state?.prevurl || "/");
            setFormData({
              username: "",
              password: "",
            });
          })
          .catch((error) => {
            toast.error("Invalid username or password!");
            console.log(error);
          });
      }
    }
  };

  const showPassword = () => {
    if (type === "text") setType("password");
    if (type === "password") setType("text");
  };

  return (
    <Stack
      style={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f7fa",
      }}
    >
      <Stack
        flexDirection={"row"}
        justifyContent={"space-between"}
        gap={windowWidth > 1000 ? "260px" : "60px"}
        flexWrap={"wrap"}
      >
        <Stack
          sx={{
            display: `${windowWidth < 800 ? "none" : ""}`,
          }}
          alignContent={"center"}
          justifyContent={"center"}
        >
          <div
            style={{
              width: "350px",
            }}
          >
            <img alt="Login" width={"100%"} src={loginImage} />
          </div>
        </Stack>
        <Box
          style={{
            paddingTop: "30px",
            paddingBottom: "30px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#fff",
            gap: "20px",
            borderRadius: "10px",
            minWidth: "400px",
            boxShadow: `${windowWidth < 800 ? "none" : "1px 2px 10px 0px rgba(0, 0, 0, 0.2)"
              }`,
          }}
        >
          <div>
            <img width={"160px"} src={HipShipGreen} alt="" draggable={false} />
          </div>
          <form onSubmit={handleSubmit}>
            <Box>
              <FormLabel>
                <Typography fontSize={12}>Username</Typography>
              </FormLabel>
              <StyledInput
                sx={{
                  borderRadius: "10px",
                  minWidth: "300px",
                }}
                margin="normal"
                id="username"
                name="username"
                autoComplete="username"
                autoFocus
                value={formData.username}
                onChange={handleInputChange}
                error={Boolean(isError.username)}
                focused={Boolean(isError.username)}
                helperText={isError.username && isError.username}
                fullWidth
              />
            </Box>
            <FormLabel>
              <Typography fontSize={12}>Password</Typography>
            </FormLabel>
            <StyledInput
              sx={{
                borderRadius: "10px",
              }}
              margin="normal"
              name="password"
              type={type}
              id="password"
              autoComplete="current-password"
              value={formData.password}
              onChange={handleInputChange}
              error={Boolean(isError.password)}
              focused={Boolean(isError.password)}
              helperText={isError.password && isError.password}
              fullWidth
            />
            <Link
              style={{
                fontSize: "10px",
                fontWeight: "500",
              }}
              to={"/forgot-password"}
            >
              Forgot Password?
            </Link>

            <FormGroup onChange={showPassword}>
              <FormControlLabel
                control={<Checkbox size="small" />}
                label={<Typography fontSize={12}>Show Password</Typography>}
              />
            </FormGroup>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                type="submit"
                fullWidth
                disabled={!canSubmit}
                variant="contained"
                // sx={{
                //   mt: 3,
                //   mb: 2,
                //   borderRadius: "10px",
                //   width: "140px",
                // }}
                sx={{
                  backgroundColor: "#77b2dc",
                  padding: "10px 50px",
                  border: "0px",
                  borderRadius: "10px",
                  boxShadow: "-0px -0px 1px #77b2dc, 2px 2px 4px #0000004b",
                  ":hover": {
                    backgroundColor: "#77b2dcd2 !important",
                    border: "0px",
                  },
                  ":disabled": {
                    backgroundColor: "#77b2dc",
                    color: "#fff",
                    pointerEvents: "auto !important",
                    cursor: "not-allowed !important",
                  },
                }}
              >
                Login
              </Button>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Link to="/register">
                <Button
                  style={{
                    textTransform: "initial",
                    marginTop: "16px",
                    color: "indigo[500]",
                  }}
                >
                  Don't have an account?
                </Button>
              </Link>
            </div>
          </form>
        </Box>
      </Stack>
    </Stack>
  );
};

export default Login;
